<template>
  <el-dialog title="班组考勤" :visible.sync="dialogVisible" v-loading="loading" :before-close="handleClose">
    <div class="content">
      <div class="base_info">
        <div class="left">
          <span class="label">班组名称：</span>
          <span class="value">{{ info?.yhTeamAttendance?.teamName }}</span>
        </div>
        <div class="right">
          <span class="label">签到项目：</span>
          <span class="value">{{ info?.yhTeamAttendance?.projectName }}</span>
        </div>
      </div>
      <div class="title">签到信息</div>

      <div class="attendance_box">
        <div class="count">上班签到：{{ onSignNum() }}人</div>
        <div class="item" v-for="(item, index) in info.onSignRecords" :key="index">
          <div class="img">
            <el-image :src="item.signImage" :preview-src-list="[item.signImage]" fit="fill" ref="preview">
            </el-image>
          </div>
          <div class="item_info">
            <div class="line line_height30">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/sign_count.svg"></div>
                签到人数：
              </div>
              <span class="value">{{ item.signNum }}人</span>
            </div>
            <div class="correct" v-if="item.modifyFlag === 'Y'">
              <p>系统识别人数：{{ item.systemIdentifyNum }}人</p>
              <p>纠偏人：<span class="mr10">{{ item.updateUserName }}</span>纠偏时间：{{ item.updateTime }}</p>
            </div>
            <div class="line">
              <div class="label">
                <div class="sign_img"><img :src='imgSrc(item.resignFlag)'></div>
                上班签到：
              </div>
              <span class="value">{{ item.signTime }}</span>
            </div>
            <div class="line">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                签到地点：
              </div>
              <span class="value">{{ item.signAddress }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="attendance_box" v-if="info?.offSignRecords?.length">
        <div class="count">下班签到：{{ offSignNum() }}人</div>
        <div class="item" v-for="(item, index) in info.offSignRecords" :key="index">
          <div class="img">
            <el-image :src="item.signImage" :preview-src-list="[item.signImage]" fit="fill" ref="preview">
            </el-image>
          </div>
          <div class="item_info">
            <div class="line line_height30">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/sign_count.svg"></div>
                签到人数：
              </div>
              <span class="value">{{ item.signNum }}人</span>
            </div>
            <div class="correct" v-if="item.modifyFlag === 'Y'">
              <p>系统识别人数：{{ item.systemIdentifyNum }}人</p>
              <p>纠偏人：<span class="mr10">{{ item.updateUserName }}</span>纠偏时间： {{ item.updateTime }}</p>
            </div>
            <div class="line">
              <div class="label">
                <div class="sign_img"><img :src='imgSrc(item.resignFlag)'></div>
                下班签到：
              </div>
              <span class="value">{{ item.signTime }}</span>
            </div>
            <div class="line">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                签到地点：
              </div>
              <span class="value">{{ item.signAddress }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="title" v-if="info?.overtimeRecords?.length">加班信息</div>
      <div class="attendance_box" v-if="info?.overtimeRecords?.length">
        <div class="item" v-for="(item, index) in info.overtimeRecords" :key="index">
          <div class="img">
            <div class="img" v-if="item?.fileList?.length">
              <div class="imgBlock" v-for="(itemImg, imgIndex) in item.fileList" :key="imgIndex">
                <el-image :src="itemImg.filePrefix + itemImg.fileUrl" :preview-src-list="item.fileList | imgListFormat"
                  fit="fill" ref="preview">
                </el-image>
              </div>
            </div>
          </div>
          <div class="item_info">
            <div class="line">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/work_overtime_count.svg"></div>
                加班人数：
              </div>
              <span class="value">{{ item.overtimeNum }}人</span>
            </div>
            <div class="line">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/work_overtime.svg"></div>
                加班时长：
              </div>
              <span class="value">{{ item.overtimeHours }}小时</span>
            </div>
            <div class="line">
              <div class="label">
                <div class="sign_img"><img src="@/assets/img/attendance/workovertime_remark.svg"></div>
                加班备注：
              </div>
              <span class="value">{{ item.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'WorkerListDetails',
  props: {
    id: {
      type: String,
      default: ''
    },
    detailsShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      info: {
        onSignRecords: [],
        offSignRecords: [],
        overtimeRecords: [],
        yhTeamAttendance: {}
      }
    }
  },
  watch: {
    detailsShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }
  },
  filters: {
    imgListFormat (list) {
      const imgList = list.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return imgList || []
    }
  },
  methods: {
    getDetail () {
      // this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhTeamAttendanceDetail, { attendanceId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      }).finally(() => {
        // this.loading = false
      })
    },

    onSignNum () {
      let num = 0
      this.info.onSignRecords.forEach((item) => {
        num = num + item.signNum
      })
      return num
    },

    offSignNum () {
      let num = 0
      this.info.offSignRecords.forEach((item) => {
        num = num + item.signNum
      })
      return num
    },

    handleClose () {
      // console.log('关闭弹窗')
      this.$emit('update:detailsShow', false)
      this.info = {
        onSignRecords: [],
        offSignRecords: [],
        overtimeRecords: [],
        yhTeamAttendance: {}
      }
    },

    imgSrc (val) {
      // console.log('图片处理', val)
      if (val) {
        if (val === 'Y') {
          return require('@/assets/img/attendance/card_replacement.svg')
        } else {
          return require('@/assets/img/attendance/sign.svg')
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 10px;
  width: 761px;
  height: 680px;
}

.el-image {
  width: 100%;
  height: 100%;
}

.content {
  padding: 10px;
  font-size: 12px;
  height: 580px;
  overflow-y: auto;
  overflow-x: hidden;

  .base_info {
    line-height: 30px;
    display: flex;
    font-size: 14px;

    .left,
    .right {
      display: flex;

      .label {
        width: 80px;
      }

      .value {
        flex: 1;
      }
    }

    .left {
      width: 200px;
    }

    .right {
      flex: 1;
    }
  }

  .title {
    line-height: 50px;
    font-size: 14px;
  }

  .attendance_box {
    width: 700px;
    min-height: 264px;
    padding: 20px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-bottom: 30px;

    .item {
      // width: ;
      height: 214px;
      // background-color: skyblue;
      margin-bottom: 30px;
      display: flex;

      .imgBlock {
        width: 100%;
        height: 100%;
      }

      .img {
        width: 214px;
        height: 214px;
        background-color: yellowgreen;
        margin-right: 47px;
        overflow: hidden;

        img {
          // width: 100%;
          width: 214px;
          height: 214px;
        }
      }

      .item_info {
        flex: 1;
      }

      .line {
        // line-height:50px;
        // .label{
        //   width: 80px;
        // }
        display: flex;

        .label {
          width: 95px;
          line-height: 50px;
          height: 50px;
          display: flex;
          align-items: center;

          .sign_img {
            width: 20px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-right: 5px;
            // height: 20px;
          }
        }

        .value {
          flex: 1;
          line-height: 50px;
        }
      }
    }

    .count {
      line-height: 40px;
      font-size: 13px;
    }

    .correct {
      padding-left: 10px;
      color: #1DCFAF;

      p {
        margin-bottom: 5px;

        span {
          margin-right: 10px;
        }
      }
    }

    .line_height30 {
      line-height: 30px !important;
    }

    .item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
